import React from 'react';

const GitHubIcon = () => (
    <svg version='1'
        className='git-hub-icon'
        id='Layer_1'
        xmlns='http://www.w3.org/2000/svg'
        width='36'
        height='36'
        viewBox='0 0 36 36'>
        <path fillRule='evenodd' clipRule='evenodd' fill='#231E1B'
            d='M17.999,2.113C9.004,2.113,1.71,9.406,1.71,18.403	c0,7.196,4.667,13.302,11.141,15.456c0.814,0.149,1.112-0.354,1.112-0.785c0-0.387-0.014-1.411-0.022-2.771	C9.41,31.288,8.454,28.12,8.454,28.12c-0.741-1.882-1.809-2.383-1.809-2.383c-1.479-1.011,0.112-0.99,0.112-0.99	c1.635,0.115,2.495,1.679,2.495,1.679c1.453,2.489,3.813,1.771,4.741,1.354c0.148-1.053,0.569-1.771,1.034-2.178	c-3.617-0.411-7.42-1.809-7.42-8.051c0-1.778,0.635-3.232,1.677-4.371c-0.167-0.412-0.727-2.068,0.16-4.311	c0,0,1.368-0.438,4.479,1.67c1.299-0.361,2.693-0.542,4.078-0.548c1.383,0.006,2.777,0.187,4.078,0.548	c3.11-2.108,4.475-1.67,4.475-1.67c0.889,2.243,0.33,3.899,0.162,4.311c1.044,1.139,1.674,2.593,1.674,4.371	c0,6.258-3.809,7.635-7.438,8.038c0.585,0.503,1.106,1.497,1.106,3.017c0,2.178-0.02,3.935-0.02,4.469	c0,0.436,0.293,0.942,1.12,0.783c6.467-2.158,11.13-8.26,11.13-15.454C34.29,9.406,26.996,2.113,17.999,2.113z'
        />
    </svg>
);

export default GitHubIcon;